export default "__VITE_ASSET__99b8ad8e__"